// extracted by mini-css-extract-plugin
export default {"goBack":"go-back_goBack__2BIQJ","light":"go-back_light__d7gP7","dark":"go-back_dark__ZChF1"};